export const unsafeGet = (data: any, keys: string[]) => {
  if (!keys?.length) return data;

  try {
    return unsafeGet(data[keys[0]], keys.slice(1));
  } catch (e) {
    return null;
  }
};
